import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PushLiveService } from '@core/services/push-live/push-live.service';
import { AuthService } from '@core/services/auth/auth.service';
import { Subscription } from 'rxjs';
import { ActivityNextItem } from '@core/models/common/activity-next-item.model';

@Component({
  selector: 'app-push-live-entry',
  template: `<p class="text-center mt-10">Loading...</p>`,
})
export class PushLiveEntryComponent implements OnInit, OnDestroy {
  pushLiveUuid!: string;
  userUuid!: string;

  private enterSub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private pushLiveService: PushLiveService,
    private readonly authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.pushLiveUuid = this.route.snapshot.paramMap.get('pushLiveUuid')!;
    this.userUuid = this.route.snapshot.paramMap.get('userUuid')!;

    this.enterSub = this.pushLiveService
      .enterPushLive(this.pushLiveUuid, this.userUuid)
      .subscribe((res) => {
        if (!res) {
          return;
        }
        const user = res.user;
        const nextItem = res.next_item;

        this.authService.storeUserToken({
          data: user,
          statusCode: 200,
          message: 'success',
          error: false,
          errorBags: null,
        });

        this.redirectToNext(nextItem);
      });
  }

  redirectToNext(nextItem: ActivityNextItem | null): void {
    if (!nextItem) {
      return;
    }

    if (nextItem.item_type === 'questionSet') {
      this.router.navigate([`/push/${this.pushLiveUuid}/test/${nextItem.item_uuid}`]);
    } else if (nextItem.item_type === 'lesson') {
      this.router.navigate([`/push/${this.pushLiveUuid}/lesson/${nextItem.item_uuid}`]);
    } else if (nextItem.item_type === 'certificate') {
      this.router.navigate([`/push-live/${nextItem.item_uuid}/certificate`]);
    } else if (nextItem.item_type === 'certified') {
      if (nextItem.item_uuid) {
        window.open(nextItem.item_uuid, '_blank');
      }
    }
  }

  ngOnDestroy(): void {
    if (this.enterSub) {
      this.enterSub.unsubscribe();
    }
  }
}
